/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Galih Bagus",
  title: "Hi all, I'm Galih Bagus",
  subTitle: emoji(
    "A passionate Full Stack Websiste Developer 🚀 having an experience of building Webiste applications with Laravel / VueJs / Nodejs and some other cool libraries and frameworks. As a Quality Assurance 🚀 having an experience of Manual and Automation testing with CypressJs / Selenium Js / Mocha and Chai Js"
  ),
  resumeLink:
    "https://drive.google.com/file/d/17hUM3DieO_jPGejyiQRHGWE26ZUlIlJw/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/galih-bagus",
  linkedin: "https://www.linkedin.com/in/galih-bagus-067252208/",
  gmail: "galihbagus333@gmail.com",
  gitlab: "https://gitlab.com/galih.bagus",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "CRAZY FULL STACK DEVELOPER WEBSITE AND QUALITY ASSURANCE WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji("⚡ Develop highly interactive Website applications"),
    emoji(
      "⚡ Make Sure about application is good no defect or bugs before up to production"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Selenium JS",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Cypress JS",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Mocha and Chai JS",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Webdriver.io",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Katalon",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "HTML-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Bootstrap",
      fontAwesomeClassname: "fab fa-bootstrap"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Laravel",
      fontAwesomeClassname: "fab fa-laravel"
    },
    {
      skillName: "Codeigniter3",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "PHP",
      fontAwesomeClassname: "fab fa-php"
    },
    {
      skillName: "NodeJS",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "NPM",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "MySql",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Github",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "Gitlab",
      fontAwesomeClassname: "fab fa-gitlab"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Jember State Polytechnic",
      logo: require("./assets/images/polije.png"),
      subHeader: "Bachelor of Applied Computer Science",
      duration: "September 2017 - October 2021"
      // descBullets: [
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      //   "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      // ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend Developer", //Insert stack or technology you have experience in
      progressPercentage: "70%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Frontend Developer",
      progressPercentage: "40%"
    },
    {
      Stack: "Automation Testing",
      progressPercentage: "55%"
    },
    {
      Stack: "Manual Testing",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Quality Assurance",
      company: "Javan Cipta Solusi",
      companylogo: require("./assets/images/javan.png"),
      date: "September 2023 – Present",
      desc: "As Quality Assurance in javan cipta solusi my job desc is :",
      descBullets: [
        "Create test cases based on user stories & tasks in Taiga",
        "Perform functional test, regression test, smoke test from the test case created",
        "Conduct analysis and create issues that Found during testing",
        "Retest issues that have been fixed",
        "Follow up on test results and issues to the project team",
        "Create Automation testing based on test case"
      ]
    },
    {
      role: "Freelance Technical Writer",
      company: "Javan Cipta Solusi",
      companylogo: require("./assets/images/javan.png"),
      date: "November 2023 – December 2023",
      desc: "As Technical Writer in javan cipta solusi my job desc is :",
      descBullets: ["Create User Guide"]
    },
    {
      role: "Freelance Software Tester",
      company: "Freelance",
      companylogo: require("./assets/images/freelance.png"),
      date: "August 2023 – September 2023",

      desc: "As Freelance Software Tester my job desc is :",
      descBullets: [" Tracking Bug", "Report Bug"]
    },
    {
      role: "Freelance Fullstack Website Developer",
      company: "Freelance",
      companylogo: require("./assets/images/freelance.png"),
      date: "June 2023 – September 2023",
      desc: "As Freelance Fullstack Website Developer my job desc is :",
      descBullets: ["Develop Web Apps"]
    },
    {
      role: "Fullstack Website Developer",
      company: "Lima Digital ID",
      companylogo: require("./assets/images/lima.png"),
      date: "October 2021 – May 2023",
      desc: "As Fullstack Website Developer in Lima Digital ID my job desc is :",
      descBullets: [
        "Develop Web Apps",
        "Maintenance Web Apps",
        "Create API for Collaborate With Mobile Developer or Front End Developer"
      ]
    },
    {
      role: "Internship Fullstack Website Developer",
      company: "Jember State Polytechnic",
      companylogo: require("./assets/images/polije.png"),
      date: "October 2021 – May 2023",
      desc: "As Internship Fullstack Website Developer in Jember State Polytechnic my job desc is :",
      descBullets: [
        "Build Website Apps for Thesis Submission Information Technology Department"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md  */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME PROJECTS I HAVE COMPLETED",
  projects: [
    {
      image: require("./assets/images/yongma.png"),
      projectName: "YongMa",
      projectDesc:
        "As Quality Assurance I perform create test case, functional testing, regression testing, exploratory testing, create issue if found during testing, retest issue after fixed, and follow up test result and issue to team project, and UAT."
    },
    {
      image: require("./assets/images/XLSmart.svg.png"),
      projectName: "XLSMART",
      projectDesc:
        "As Quality Assurance I perform create test case, functional testing, smoke testing, regression testing, exploratory testing, create issue if found during testing, retest issue after fixed, and follow up test result and issue to team project, Create and Run Automation Testing, Create and Run Performance Testing."
    },
    {
      image: require("./assets/images/LinkNet.png"),
      projectName: "Link Net",
      projectDesc:
        "As Quality Assurance I perform create test case, functional testing, smoke testing, regression testing, exploratory testing, create issue if found during testing, retest issue after fixed, and follow up test result and issue to team project."
    },
    {
      image: require("./assets/images/KPK_Logo.svg.png"),
      projectName: "KPK",
      projectDesc: "As Technical Writer I perform create User Guide"
    },
    {
      image: require("./assets/images/kominfo.webp"),
      projectName: "Kominfo",
      projectDesc:
        "As Quality Assurance I perform create test case, functional testing, smoke testing, regression testing, exploratory testing, create issue if found during testing, retest issue after fixed, and follow up test result and issue to team project."
    },
    {
      image: require("./assets/images/etams.png"),
      projectName: "Etams Produksi",
      projectDesc:
        "As Fullstack Developer Website I develop website applications and as Software Tester I do testing to ensure all features work properly"
    },
    {
      image: require("./assets/images/jvto.png"),
      projectName: "Java Volcano Tour Operator",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/goshuttle1.png"),
      projectName: "Go Shuttle",
      projectDesc:
        "As Fullstack Developer Website I develop website applications and create API for collaborate with Mobile Developer."
    },
    {
      image: require("./assets/images/showroom52.png"),
      projectName: "SHOWROOM 52 JEMBER",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/elitetrans.png"),
      projectName: "ELITE TRANS",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/bsis1.png"),
      projectName: "BANK SAMPAH INDUK SURABAYA",
      projectDesc:
        "As Fullstack Developer Website I develop website applications and create API for collaborate with Mobile Developer."
    },
    {
      image: require("./assets/images/disposisi.png"),
      projectName: "DISPOSISI SURAT",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/sipmendik.png"),
      projectName: "SIPMENDIK",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/puskogap.png"),
      projectName: "PUSKOGAP",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/cofeetofee.png"),
      projectName: "MEMBER COFFE TOFFE",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/klinik-again.png"),
      projectName: "SIM KLINIK AGIAN MEDICAL CENTER",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    },
    {
      image: require("./assets/images/ui.png"),
      projectName: "U&I Payment System",
      projectDesc:
        "As Fullstack Developer Website I develop website applications."
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        {name: "Certification", url: ""},
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "6283847023896",
  email_address: "galihbagus333@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
